module.exports = __webpack_public_path__ + "static/media/ZonalMap_Large.6c3f773d.png";